export const ACCOUNT_DEACTIVATION_SECTION_TEST_IDS = {
    section: "account-deactivation-section",
    title: "account-deactivation-section-title",
    description: "account-deactivation-section-description",
    content: "account-deactivation-section-content",
    deactivateLink: "account-deactivation-link",
} as const;
